/**
 * チケット（通常・L サイズ・変形サイズ）の注文（価格表の表示とカート追加）
 * MEMO: 旧 js/order-ticket.js の ESM 版
 *       用紙・オプション・加工の選択 UI は、src/order-common が #j-nxg_* の hidden input に値を入れる
 */
import '@/order-common'
import { setPriceLoader } from '@/order-common/price-loader'
import { onReady } from '@/utils/dom'
import { createPriceTableLoader, initPriceLinkAddCart } from '@/utils/order-price-table'

//印刷タイプ（片面白黒・両面白黒・片面カラー・カラー×白黒・両面カラー）
const PRINT_TYPES = ['OPT_PRINT_TYPE_1_0', 'OPT_PRINT_TYPE_1_1', 'OPT_PRINT_TYPE_4_0', 'OPT_PRINT_TYPE_4_1', 'OPT_PRINT_TYPE_4_4']

const loadPriceTable = createPriceTableLoader({
    printTypes: PRINT_TYPES,
    maxLotAmount: 50,
    unitNum: 100,
    lotName: 'セット',
    getLayout: () => ({
        pc: PRINT_TYPES,
        mobile: [
            ['#order-price_table_mobile-01 tbody', ['OPT_PRINT_TYPE_1_0', 'OPT_PRINT_TYPE_1_1', 'OPT_PRINT_TYPE_4_0']],
            ['#order-price_table_mobile-02 tbody', ['OPT_PRINT_TYPE_4_1', 'OPT_PRINT_TYPE_4_4']],
        ],
    }),
})

onReady(() => {
    setPriceLoader(loadPriceTable)
    loadPriceTable()
    initPriceLinkAddCart()
})
